export const TALENT_SORTABLE_FIELDS = [
  "talent.talentNumber",
  "talent.fullName",
  "talent.nickName",
  "nationality.nationalityName",
  "talent.recruitmentStatus",
  "caseMatchStatus",
  "residenceStatus.residenceStatus",
  "languageTestLevel.level",
  "companySpecificIndustry.companySpecificIndustry",
  "personInCharge.fullName",
  "talent.createdAt",
  "talent.desiredWorkLocation",
  "talent.location",
  "partner.partnerName",
  "talent.heldQualifications",
  "educationBackgrounds.educationLevelId",
] as const;

export const JOB_SORTABLE_FIELDS = [
  "job.managementNumber",
  "job.status",
  "job.tag",
  "company.companyName",
  "job.jobName",
  "recruiter.fullName",
  "companySpecificIndustry.companySpecificIndustry",
  "job.japaneseLevelType",
  "job.createdAt",
] as const;

export const CASE_SORTABLE_FIELDS = ["case.progressStatus", "case.name", "job.jobName", "company.companyName", "personInCharge.fullName", "case.createdAt"] as const;

export const COMPANY_SORTABLE_FIELDS = [
  "managementNumber",
  "companyName",
  "mainIndustryId",
  "prefecture",
  "contactPersonName",
  "companySpecificIndustryId1",
  "createdAt",
] as const;

export const PARTNER_SORTABLE_FIELDS = ["managementNumber", "partnerName", "nationalityName", "location", "contactPerson", "createdAt"] as const;

export const CASE_MATCH_SORTABLE_FIELDS = [
  "talent.talentNumber",
  "talent.fullName",
  "talent.nickName",
  "nationality.nationalityName",
  "residenceStatus.residenceStatus",
  "talent.periodOfStay",
  "languageTestLevel.level",
  "personInCharge.fullName",
] as const;

export type TTalentSortableField = (typeof TALENT_SORTABLE_FIELDS)[number];
export type TJobSortableField = (typeof JOB_SORTABLE_FIELDS)[number];
export type TCaseSortableField = (typeof CASE_SORTABLE_FIELDS)[number];
export type TCompanySortableField = (typeof COMPANY_SORTABLE_FIELDS)[number];
export type TPartnerSortableField = (typeof PARTNER_SORTABLE_FIELDS)[number];
export type TCaseMatchSortableField = (typeof CASE_MATCH_SORTABLE_FIELDS)[number];
